/* src/app/gest-ristorante/gest-ristorante.component.css */
@media screen and (max-width: 767px) and (min-width: 320px) {
  .alert-danger {
    font-size: 1.6vh !important;
  }
}
/*# sourceMappingURL=gest-ristorante.component.css.map */
